import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/order_statistics',
  component: Management,
  redirect: '/order_statistics/tabs',
  children: [
    {
      path: 'tabs',
      component: () => import('@/views/order_statistics/OrderStatisticsLayout'),
      redirect: '/order_statistics/tabs/time_group_statistics',
      meta: {
        auth: Auth.showOrder
      },
      children: [
        // 时间分组统计
        {
          path: 'time_group_statistics',
          component: () => import('@/views/order_statistics/TimeGroupStatistics'),
          meta: {
            auth: Auth.showOrderStatistics
          }
        },
        // 属性分组统计
        {
          path: 'prop_group_statistics',
          component: () => import('@/views/order_statistics/PropGroupStatistics'),
          meta: {
            auth: Auth.showOrderStatistics
          }
        },
        // 优惠分组统计
        {
          path: 'discount_group_statistics',
          component: () => import('@/views/order_statistics/DiscountGroupStatistics'),
          meta: {
            auth: Auth.showOrderStatistics
          }
        }
      ]
    }
    // {
    //   path: 'dashboard',
    //   component: () => import('@/views/order_statistics/Dashboard'),
    //   meta: {
    //     auth: Auth.showOrderStatistics
    //   }
    // },
    // 时间分组统计
    // {
    //   path: 'time_group_statistics',
    //   component: () => import('@/views/order_statistics/TimeGroupStatistics'),
    //   meta: {
    //     auth: Auth.showOrderStatistics
    //   }
    // },
    // 属性分组统计
    // {
    //   path: 'prop_group_statistics',
    //   component: () => import('@/views/order_statistics/PropGroupStatistics'),
    //   meta: {
    //     auth: Auth.showOrderStatistics
    //   }
    // },
    // 优惠分组统计
    // {
    //   path: 'discount_group_statistics',
    //   component: () => import('@/views/order_statistics/DiscountGroupStatistics'),
    //   meta: {
    //     auth: Auth.showOrderStatistics
    //   }
    // }
  ]
}
